import {
    GET_ROOMS
} from '../../constants/actions'

const initialState = {
    rooms: []
}


export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ROOMS:
            return {
                ...state,
                rooms: action.payload
            }
        default:
            return state
    }
}